export default __webpack_public_path__ + "static/media/karriere.2b78a5c2.webp";